import ViewMgtDeviceStatusMap from "./ViewMgtDeviceStatusMap";
import ViewMgtDeviceStatusLock from "./ViewMgtDeviceStatusLock";
import ViewMgtDeviceStatusInfo from "./ViewMgtDeviceStatusInfo";
import ViewMgtDeviceStatusEvents from "./ViewMgtDeviceStatusEvents";
import ViewMgtDeviceStatusClient from "./ViewMgtDeviceStatusClient";
import ViewMgtDeviceStatusRemotes from "./ViewMgtDeviceStatusRemotes";
import ViewMgtDeviceStatusVehicle from "./ViewMgtDeviceStatusVehicle";
import ViewMgtDeviceStatusLocation from "./ViewMgtDeviceStatusLocation";
import ViewMgtDeviceStatusIgnition from "./ViewMgtDeviceStatusIgnition";
import ViewMgtDeviceStatusSatellites from "./ViewMgtDeviceStatusSatellites";
import ViewMgtDeviceStatusPanicButtons from "./ViewMgtDeviceStatusPanicButtons";
import ViewMgtDeviceStatusInternalBattery from "./ViewMgtDeviceStatusInternalBattery";

export default function ViewMgtDeviceStatus({ deviceId, device }: { deviceId?: string | null | undefined, device?: any | undefined | null }) {
  return (
    <div className="relative w-full">
      <div className="container mx-auto px-4">

        <div className="grid w-full gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          <ViewMgtDeviceStatusMap deviceId={deviceId} device={device} />
          <ViewMgtDeviceStatusLocation deviceId={deviceId} device={device} />
          <ViewMgtDeviceStatusLock deviceId={deviceId} device={device} />
          <ViewMgtDeviceStatusIgnition deviceId={deviceId} device={device} />
          <ViewMgtDeviceStatusInfo deviceId={deviceId} device={device} />
          <ViewMgtDeviceStatusVehicle deviceId={deviceId} device={device} />
          <ViewMgtDeviceStatusInternalBattery deviceId={deviceId} device={device} />
          <ViewMgtDeviceStatusClient deviceId={deviceId} device={device} />
          <ViewMgtDeviceStatusSatellites deviceId={deviceId} device={device} />
          <ViewMgtDeviceStatusRemotes deviceId={deviceId} device={device} />
          <ViewMgtDeviceStatusPanicButtons deviceId={deviceId} device={device} />
        </div>

        <div className="w-full mt-6" style={{height: 400}}>
          <ViewMgtDeviceStatusEvents deviceId={deviceId} device={device} />
        </div>
      </div>
    </div>
  );
}
